import React from 'react';
import { Form, Input, Button, Space } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';

// Rows of URL + optional label inside a Form, stored under `name` as
// [{url, label}]. Used for a recap template's default links and for the links
// on Generate Coaching Recap.
export default function LinksFormList({ name = 'urls' }) {
  return (
    <Form.List name={name}>
      {(fields, { add, remove }) => (
        <Space direction="vertical" style={{ width: '100%' }} size={6}>
          {fields.map(({ key, name: row }) => (
            <Space key={key} align="baseline" wrap>
              <Form.Item name={[row, 'url']} noStyle
                         rules={[{ type: 'url', message: 'Enter a full link, e.g. https://…' }]}>
                <Input placeholder="URL" style={{ width: 420 }} />
              </Form.Item>
              <Form.Item name={[row, 'label']} noStyle>
                <Input placeholder="Label (optional)" style={{ width: 240 }} />
              </Form.Item>
              <MinusCircleOutlined onClick={() => remove(row)} style={{ color: '#999' }} />
            </Space>
          ))}
          <Button type="dashed" icon={<PlusOutlined />} onClick={() => add()}>Add Link</Button>
        </Space>
      )}
    </Form.List>
  );
}

// [{url, label}] with blank URLs dropped and whitespace trimmed.
export const cleanLinks = (links) => (links || [])
  .filter((u) => u?.url?.trim())
  .map((u) => ({ url: u.url.trim(), label: u.label?.trim() || null }));
